import React from "react";
import ScientistStory from "../home/ScientistStory";
import InvestorStory from "../home/InvestorStory";
import TreatmentStory from "../home/TreatmentStory";
import "../home/AudienceHome.css";

export default function AudienceSite({ audience, page = "overview" }) {
  return (
    <main id="main-content" className="audience-home" data-site={audience}>
      <div className="audience-story" key={`${audience}/${page}`}>
        {audience === "scientist" && <ScientistStory page={page} />}
        {audience === "investor" && <InvestorStory page={page} />}
        {audience === "treatment" && <TreatmentStory page={page} />}
      </div>
    </main>
  );
}
